import { call, fork, take } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'

import { GooglePostApi } from '../../api/instances'

import { getGooglePageFeed, getGooglePageFeedInitiated } from './googleMyBusiness.actions'

import { GetGooglePageFeedRequest } from '@3m5/sm_publish-frontend-api/apis/GooglePostApi'

// getGooglePageFeed
const getGooglePageFeedWorker = bindAsyncAction(getGooglePageFeed)(
  function * (params: GetGooglePageFeedRequest) {
    return yield call([GooglePostApi, GooglePostApi.getGooglePageFeed], params)
  },
)

function * watchGetGooglePageFeedInitiated () {
  while (true) {
    const action: Action<GetGooglePageFeedRequest> = yield take(getGooglePageFeedInitiated)
    try {
      yield getGooglePageFeedWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetGooglePageFeedInitiated: ', e)
    }
  }
}

export function * googleMyBusinessSagas () {
  yield fork(watchGetGooglePageFeedInitiated)
}
